import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <div className="logo" />
    <p>
      <a target="_blank" rel="noopener noreferrer" href="https://auth0.com">
        Auth0
      </a>
    </p>
  </footer>
);

export default Footer;
